import { CommonModule, NgForOf, NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import {
  TuiAlertService,
  TuiAppearance,
  TuiButton,
  TuiLink,
  TuiLoader,
} from "@taiga-ui/core";
import { TuiBreadcrumbs, TuiFade } from "@taiga-ui/kit";
import { TuiNavigation } from "@taiga-ui/layout";
import { NurseService } from "../../core/services/nurse.service";
import { Breadcrumb } from "../../model/interface/breadcrumb";

@Component({
  selector: "app-admin-control",
  standalone: true,
  imports: [
    CommonModule,
    NgIf,
    NgForOf,
    TuiAppearance,
    TuiBreadcrumbs,
    TuiButton,
    TuiFade,
    TuiLink,
    TuiLoader,
    TuiNavigation,
  ],
  templateUrl: "./admin-control.component.html",
  styleUrl: "./admin-control.component.scss",
})
export class AdminControlComponent {
  breadcrumbs: Breadcrumb[] = [
    { label: "Royal Hospital" },
    { label: "Admin Control" },
  ];

  syncing = false;
  result: {
    migrated: number;
    skippedManual: number;
    alreadyCanonical: number;
    conflicts: string[];
  } | null = null;

  constructor(
    private nurseService: NurseService,
    private alerts: TuiAlertService,
    private router: Router
  ) {}

  navigate(link?: string): void {
    if (link) this.router.navigate([link]);
  }

  syncNurseCasualIds(): void {
    this.syncing = true;
    this.result = null;
    this.nurseService.syncCasualIds().subscribe({
      next: (res: any) => {
        this.syncing = false;
        this.result = res?.data ?? null;
        this.alerts
          .open(
            `Migrated ${this.result?.migrated ?? 0} nurse casual ID(s).`,
            { label: "Sync complete", appearance: "success" }
          )
          .subscribe();
      },
      error: (err) => {
        this.syncing = false;
        this.alerts
          .open(err?.error?.message || "Failed to sync nurse casual IDs", {
            label: "Error",
            appearance: "negative",
          })
          .subscribe();
      },
    });
  }
}
